const host="https://ariesworldsofttech.co.in/Priv_Whatsapp/apis";
export default host

//https://dashrathsilverart.com/Priv_Whatsapp/
//http://localhost/react_priv_messenger_Whatsapp/